import MyProgress from "./MyProgress";
import FollowupWeight from "./FollowupWeight";

export default MyProgress;
export { MyProgress, FollowupWeight };
